module.exports = __webpack_public_path__ + "static/soc1-f8241f643cdc875e1d0da46480e6fe59.png";